/* eslint-disable no-empty-pattern */
import React from 'react'
import { useTable } from 'react-table'
import QuantityCellState from '../../QuantityCell/QuantityCellState';




//**RENDERED TABLE COMPONENT */
function RequestCartTable({ columns, data }) {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        rows
    } = useTable({
        columns,
        data
    });

    return (
        <div id="request-cart-table">
            <table {...getTableProps({})}>
                <thead>
                    {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map(column => (
                                <th {...column.getHeaderProps({
                                    style: {
                                        minWidth: column.minWidth,
                                        maxWidth: column.maxWidht,
                                        width: column.width,
                                        textAlign: column.textAlign
                                    }
                                })}>{column.render('Header')}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>

                {rows &&
                    <tbody {...getTableBodyProps()}>
                        {rows.map((row, i) => {
                            prepareRow(row)
                            return (
                                <tr {...row.getRowProps()}>
                                    {
                                        row.cells.map(cell => {
                                            let style = {
                                                height: 50
                                            }
                                            if (cell.column.id === "qty") {
                                                style = {
                                                    height: 50,
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                }
                                    return (
                                    <td key={cell.row.original.id} style={style} {...cell.getCellProps()}>
                                        <QuantityCellState
                                            cell={cell}
                                            showTrash={true}
                                            showAddtoRequest={false}>
                                        </QuantityCellState>
                                    </td>
                                    )
                                            } else {
                                                return <td key={cell.row.original.id} style={style} {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                            }
                                        })}
                                </tr>
                            )
                        })}
                    </tbody>
                }
            </table>
        </div>

    )

}

export default RequestCartTable;